import layoutAdmin from '@/layouts/layoutAdmin.vue';
import pageNotFound from '@/views/utils/pageNotFound.vue';
import dashboard from '@/views/module/dashboard/dashboard.vue';
import moduleSetup from '@/views/module/administration/moduleManagement/moduleSetup.vue';
import subModuleSetup from '@/views/module/administration/moduleManagement/subModuleSetup.vue';
import menuSetup from '@/views/module/administration/moduleManagement/menuSetup.vue';
import roleSetup from '@/views/module/administration/roleManagement/roleSetup.vue';
import rolePermission from '@/views/module/administration/roleManagement/rolePermission.vue';
import userSetup from '@/views/module/administration/userManagement/userSetup.vue';
import changePassword from '@/views/module/administration/userManagement/changePassword.vue';
import branchSetup from '@/views/module/administration/branchManagement/branchSetup.vue';
import branchModuleSetup from '@/views/module/administration/branchManagement/branchModuleSetup.vue';
import companySetup from '@/views/module/administration/companyManagement/companySetup.vue';
import companyModuleSetup from '@/views/module/administration/companyManagement/companyModuleSetup.vue';
import approvalName from '@/views/module/administration/approvalManagement/approvalName.vue';
import approvalMatrix from '@/views/module/administration/approvalManagement/approvalMatrix.vue';
import approvalRecord from '@/views/module/administration/approvalManagement/approvalMatrixRecord.vue';
import journalRequestList from "@/views/module/accounts/journalVoucher/approvalRequestList.vue";
import journalVoucherApprovalPreview from "@/views/module/accounts/journalVoucher/approvalPreview.vue";

export default [
    {
      path: '/administration',
      name: 'administration',
      component: layoutAdmin,
      meta: {
        UserLoggedIn: true,
        breadcrumb: 'Administration',
      },
      children: [
        {
          path: "dashboard",
          meta: {
            breadcrumb: ['Dashboard']
          },
          component: dashboard,
        },
        {
          path: 'module-setup',
          name: 'module-setup',
          meta: {
            breadcrumb: ['Module Management','Module Setup'],
          },
          component: moduleSetup,
        },
        {
          path: 'sub-module-setup',
          name: 'sub-module-setup',
          meta: {
            breadcrumb: ['Module Management','Sub Module Setup'],
          },
          component: subModuleSetup,
        },
        {
          path: 'menu-setup',
          name: 'menu-setup',
          meta: {
            breadcrumb: ['Module Management','Menu Setup'],
          },
          component: menuSetup,
        },
        {
          path: 'role-setup',
          name: 'role-setup',
          meta: {
            breadcrumb: ['Role Management','Role Setup'],
          },
          component: roleSetup,
        },
        {
          path: 'role-permission',
          name: 'role-permission',
          meta: {
            breadcrumb: ['Role Management','Role Permission'],
          },
          component: rolePermission,
        },
        {
          path: 'user-setup',
          name: 'user-setup',
          meta: {
            breadcrumb: ['User Management','User Setup'],
          },
          component: userSetup,
        },
        {
          path: 'change-password',
          name: 'change-password',
          meta: {
            breadcrumb: ['User Management','Change Password'],
          },
          component: changePassword,
        },
        {
          path: 'branch-setup',
          name: 'branch-setup',
          meta: {
            breadcrumb: ['Branch Management','Branch Setup'],
          },
          component: branchSetup,
        },
        {
          path: 'branch-module-setup',
          name: 'branch-module-setup',
          meta: {
            breadcrumb: ['Branch Management','Branch Module Setup'],
          },
          component: branchModuleSetup,
        },
        {
          path: 'company-setup',
          name: 'company-setup',
          meta: {
            breadcrumb: ['Company Management','Company Setup'],
          },
          component: companySetup,
        },
        {
          path: 'company-module-setup',
          name: 'company-module-setup',
          meta: {
            breadcrumb: ['Company Management','Company Module Setup'],
          },
          component: companyModuleSetup,
        },
        {
          path: 'company-module-setup',
          name: 'company-module-setup',
          meta: {
            breadcrumb: ['Company Management','Company Module Setup'],
          },
          component: companyModuleSetup,
        },
        {
          path: 'approval-name',
          name: 'approval-name',
          meta: {
            breadcrumb: ['Approval Management','Approval Name'],
          },
          component: approvalName,
        },
        {
          path: 'approval-setup',
          name: 'approval-setup',
          meta: {
            breadcrumb: ['Approval Management','Approval Setup'],
          },
          component: approvalMatrix,
        },
        {
          path: 'my-approval',
          name: 'my-approval',
          meta: {
            breadcrumb: ['Approval Management','My Approval'],
          },
          component: approvalRecord,
        },
        {
          path: "approval-request-record",
          name: "approval-request-record",
          meta: {
            breadcrumb: ["Account Management", "Journal Request List"],
          },
          component: journalRequestList,
        },
        {
          path: "approval-process-preview/:id",
          name: "approval-process-preview",
          meta: {
            breadcrumb: ["Account Management", "Approval Preview"],
          },
          component: journalVoucherApprovalPreview,
        },
      ],
    },
  ]